export enum AppointmentsLifecycleEnum {
  FUTURE = 'scheduled',
  PAST = 'finished',
  OTHER = 'other',
}

export enum AppointmentMode {
  WITH_SLOT = 'withSlot',
  STANDALONE = 'standalone',
}

export enum AppointmentType {
  LABORATORIAL = 'laboratorial',
  NON_LABORATORIAL = 'non_laboratorial',
  SCHEDULED = 'scheduled',
}

export enum AppointmentCancelStatus {
  PENDING = 'pending',
}

export enum AppointmentStatus {
  SCHEDULED = 'scheduled',
  FINISHED = 'finished',
  CANCELED = 'canceled',
  PENDING = 'pending',
  PAID = 'paid',
  PARTIAL_CANCELED = 'partial_canceled',
}
